import firebase from 'firebase/app'
import 'firebase/firestore'

const DOMAIN_ACCESS_DOC_ID = 'domainAccess'
const DEFAULT_LINE_LINK = 'https://lin.ee/xalM4XE'
const GET_SALE_LINE_LINK_ENDPOINT = 'https://asia-east2-connextcc.cloudfunctions.net/getSaleLineLink'
const PUBLIC_API_KEY = 'LosnQ8W6uWoVs8N-ik_'
const axios = require('axios').default

const normalizeDomain = (value) => {
  const rawValue = (value || '').toString().trim().toLowerCase()
  if (!rawValue) return ''

  return rawValue
    .replace(/^https?:\/\//, '')
    .replace(/^\/\//, '')
    .split('/')[0]
    .split('?')[0]
    .split('#')[0]
    .replace(/:\d+$/, '')
}

const normalizeDomainAccess = (data) => {
  const seen = {}
  const domains = Array.isArray(data && data.domains) ? data.domains : []

  return {
    domains: domains.reduce((result, domain) => {
      const host = normalizeDomain(domain && domain.host)
      if (!host || seen[host]) return result
      seen[host] = true
      result.push({
        host,
        active: domain && domain.active === true
      })
      return result
    }, []),
    partnerReferralHost: normalizeDomain(data && data.partnerReferralHost)
  }
}

const normalizeSaleCode = (value) => {
  const rawValue = (value || '').toString().trim()
  if (!rawValue || rawValue === '0') return ''
  return rawValue.split('@')[0].trim().toLowerCase()
}

export default {
  async fetchSettings({ commit, state }) {
    // If settings already loaded, don't fetch again (save costs)
    if (state.isLoaded) {
      return
    }

    try {
      const db = firebase.firestore()
      const [settingsDoc, domainAccessDoc] = await Promise.all([
        db.collection('settings').doc('7PmpDYsLogZUTvmy22At').get(),
        db.collection('settings').doc(DOMAIN_ACCESS_DOC_ID).get()
      ])

      const domainAccess = domainAccessDoc.exists
        ? normalizeDomainAccess(domainAccessDoc.data())
        : {}

      if (settingsDoc.exists) {
        const data = settingsDoc.data()
        commit('SET_SETTINGS', {
          lineAt: data.lineAt || '@connextcc',
          linkLine: data.linkLine || DEFAULT_LINE_LINK,
          adminContactLineLink: data.adminContactLineLink || data.linkLine || DEFAULT_LINE_LINK,
          ...domainAccess
        })
      } else {
        // If document doesn't exist, use default values
        commit('SET_SETTINGS', {
          lineAt: '@connextcc',
          linkLine: DEFAULT_LINE_LINK,
          adminContactLineLink: DEFAULT_LINE_LINK,
          ...domainAccess
        })
      }
    } catch (error) {
      console.error('Error fetching settings:', error)
      // On error, use default values
      commit('SET_SETTINGS', {
        lineAt: '@connextcc',
        linkLine: DEFAULT_LINE_LINK,
        adminContactLineLink: DEFAULT_LINE_LINK
      })
    }
  },
  async resolveAdminContactLineLink({ commit, dispatch, state }, user = {}) {
    if (!state.isLoaded) {
      await dispatch('fetchSettings')
    }

    const fallbackLink = state.defaultAdminContactLineLink || state.linkLine || DEFAULT_LINE_LINK
    const salecode = normalizeSaleCode(user && user.userFriendId)

    if (!salecode) {
      commit('SET_ADMIN_CONTACT_LINE_LINK', fallbackLink)
      return fallbackLink
    }

    try {
      const response = await axios({
        method: 'post',
        url: GET_SALE_LINE_LINK_ENDPOINT,
        headers: {
          'x-api-key': PUBLIC_API_KEY,
          'Content-Type': 'application/json'
        },
        data: { salecode }
      })

      const employees = (response.data && response.data.employees) ? response.data.employees : []
      const employee = employees.length > 0 ? employees[0] : null
      const lineLink = (employee && employee.admin_contact_line) || fallbackLink

      commit('SET_ADMIN_CONTACT_LINE_LINK', lineLink)
      return lineLink
    } catch (error) {
      console.error('Error resolving admin contact line link:', error)
      commit('SET_ADMIN_CONTACT_LINE_LINK', fallbackLink)
      return fallbackLink
    }
  }
}
